import { Snackbar } from "@mui/material";
import { forwardRef, SyntheticEvent } from "react";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import { useAppDispatch, useAppSelector } from "../../../utilities/hooks/redux.hooks";
import { cleanNotification } from "./state/notification.reducer";

const Alert = forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref
) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function NotificationBar() {
  const { show, severity, message } = useAppSelector(state => state.notification);
  const dispatch = useAppDispatch();

  const handleClose = (event?: SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    dispatch(cleanNotification());
  };

  return (
      <Snackbar
        open={show}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%", background: severity === 'success' ? "#64b33b" : "#D32F2F" }}>
          {message}
        </Alert>
      </Snackbar>
  );
}

export default NotificationBar;


